import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SliderContentDelete } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchSliderContentDelete = createAsyncThunk(
    'sliderGet/fetchSliderContentDelete',
    async ({ id }) => {
        const response = await SliderContentDelete(id)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const sliderContentDeleteSlice = createSlice({
    name: 'sliderContentDelete',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderContentDelete.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSliderContentDelete.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSliderContentDelete.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default sliderContentDeleteSlice.reducer;
